class ProductCard2026 extends HTMLElement {
  connectedCallback() {
    // Defer so children are in the DOM. When the custom element class is
    // already defined, connectedCallback fires on the opening tag — before
    // children have been parsed — causing querySelector to return null for
    // every card after the first.
    setTimeout(() => this._init(), 0);
  }

  _init() {
    const dataEl = this.querySelector('.pc2026__variant-data');
    if (!dataEl) return;

    try {
      this._variants = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    this._form = this.querySelector('form');
    if (!this._form) return;

    this._variantInput = this._form.querySelector('.pc2026__variant-id');
    this._atcButton = this._form.querySelector('.pc2026__atc');
    this._atcInner = this._form.querySelector('.pc2026__atc-inner');

    this._atcText = this.dataset.atcText || 'Add to cart';
    this._soldOutText = this.dataset.soldOutText || 'Sold out';

    this._form.addEventListener('change', this._onOptionChange.bind(this));

    // Also respond to variant:update fired by the section's variant picker
    // (e.g. swatches inside the card's children block).
    const section = this.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', (event) => {
        if (event.detail?.data?.productId !== this.dataset.productId) return;
        const resource = event.detail?.resource;
        if (!resource) return;

        const variantId = String(resource.id);
        const variant = this._variants.find((v) => String(v.id) === variantId);
        if (!variant) return;

        if (this._variantInput) this._variantInput.value = resource.id;
        this._updateAtcButton(variant);
      });
    }

    // Open cart drawer after a successful add.
    this.addEventListener('cart:update', (event) => {
      if (event.detail?.data?.source === 'product-form-component' && !event.detail?.data?.didError) {
        document.querySelector('cart-drawer-component')?.open();
      }
    });
  }

  _getSelectedOptions() {
    return Array.from(this.querySelectorAll('.pc2026__option-group')).map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  _onOptionChange() {
    const selected = this._getSelectedOptions();
    const variant = this._variants.find((v) =>
      v.options.every((opt, i) => opt === selected[i])
    );
    if (!variant) return;

    if (this._variantInput) this._variantInput.value = variant.id;

    // Re-query in case morph replaced the button elements
    this._atcButton = this._form.querySelector('.pc2026__atc');
    this._atcInner = this._form.querySelector('.pc2026__atc-inner');

    this._updateAtcButton(variant);
  }

  _updateAtcButton(variant) {
    if (!this._atcButton || !this._atcInner) return;

    if (variant.available) {
      this._atcButton.disabled = false;
      this._atcInner.innerHTML =
        this._atcText +
        ' — <span class="pc2026__atc-price">' +
        variant.price +
        '</span>';
    } else {
      this._atcButton.disabled = true;
      this._atcInner.textContent = this._soldOutText;
    }
  }
}

if (!customElements.get('product-card-2026')) {
  customElements.define('product-card-2026', ProductCard2026);
}
